export interface SignatureResoureModel {
	name: string;
	url: string;
	type: ContainerType;
}

export enum ContainerType {
	Video = 0,
	Audio,
	Page,
	File
}
